import React, { FC, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';

import './App.less';

import './config/reactotronConfig';

import { DASHBOARD, LOGIN, SUBSCRIBED_USERS } from './utils/constants/routes';
import Login from './components/auth/Login';
import Dashboard from './components/Dashboard';
import styled from 'styled-components';
import storage from './utils/storage';
import { setAccessToken } from './api/network';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (storage.getUserId()) {
          return <Component {...rest} {...props} />;
        }
        return <Redirect to={LOGIN} />;
      }}
    />
  );
};

type Props = {};

const App: FC<Props> = () => {
  const history = useHistory();
  const [appLoaded, setAppLoaded] = useState(false);

  useEffect(() => {
    const accessToken = storage.getAccessToken();

    if (accessToken) {
      setAccessToken(accessToken);
      if (history.location.pathname === '/') {
        history.push(`${DASHBOARD}${SUBSCRIBED_USERS}`);
      }
    } else if (history.location.pathname === '/') {
      history.push(LOGIN);
    }

    setAppLoaded(true);
  }, []);

  if (!appLoaded) return null;

  return (
    <Container>
      <Switch>
        <ProtectedRoute path={DASHBOARD} component={Dashboard} />
        <Route path={LOGIN} component={Login} />
        <Redirect to={LOGIN} />
      </Switch>
    </Container>
  );
};

export default App;

const Container = styled.div`
  display: flex;
  flex: 1;
`;
